/**
 * 由 scripts/gen_rig_constants.py 从已落盘的真实数据自动生成，请勿手改。
 * 重新生成：python scripts/gen_rig_constants.py
 *
 * - BONE_NAMES: 65 根 Mixamo 骨骼，穷举 977 个姿势逐文件断言恒为该集合（骨骼名零偏差，见 scripts/audit_pose_library.py）
 * - CONTROL_NAMES: 25 个语义关节控制，取自 15 套站位模板的 characterRig.controls 并集
 * 实测结论：骨骼条目只含 rotation（单位弧度）；controls 单位为角度、全为整数。
 */

export const BONE_NAMES: readonly string[] = [
  'mixamorigHead',
  'mixamorigHeadTop_End',
  'mixamorigHips',
  'mixamorigLeftArm',
  'mixamorigLeftFoot',
  'mixamorigLeftForeArm',
  'mixamorigLeftHand',
  'mixamorigLeftHandIndex1',
  'mixamorigLeftHandIndex2',
  'mixamorigLeftHandIndex3',
  'mixamorigLeftHandIndex4',
  'mixamorigLeftHandMiddle1',
  'mixamorigLeftHandMiddle2',
  'mixamorigLeftHandMiddle3',
  'mixamorigLeftHandMiddle4',
  'mixamorigLeftHandPinky1',
  'mixamorigLeftHandPinky2',
  'mixamorigLeftHandPinky3',
  'mixamorigLeftHandPinky4',
  'mixamorigLeftHandRing1',
  'mixamorigLeftHandRing2',
  'mixamorigLeftHandRing3',
  'mixamorigLeftHandRing4',
  'mixamorigLeftHandThumb1',
  'mixamorigLeftHandThumb2',
  'mixamorigLeftHandThumb3',
  'mixamorigLeftHandThumb4',
  'mixamorigLeftLeg',
  'mixamorigLeftShoulder',
  'mixamorigLeftToeBase',
  'mixamorigLeftToe_End',
  'mixamorigLeftUpLeg',
  'mixamorigNeck',
  'mixamorigRightArm',
  'mixamorigRightFoot',
  'mixamorigRightForeArm',
  'mixamorigRightHand',
  'mixamorigRightHandIndex1',
  'mixamorigRightHandIndex2',
  'mixamorigRightHandIndex3',
  'mixamorigRightHandIndex4',
  'mixamorigRightHandMiddle1',
  'mixamorigRightHandMiddle2',
  'mixamorigRightHandMiddle3',
  'mixamorigRightHandMiddle4',
  'mixamorigRightHandPinky1',
  'mixamorigRightHandPinky2',
  'mixamorigRightHandPinky3',
  'mixamorigRightHandPinky4',
  'mixamorigRightHandRing1',
  'mixamorigRightHandRing2',
  'mixamorigRightHandRing3',
  'mixamorigRightHandRing4',
  'mixamorigRightHandThumb1',
  'mixamorigRightHandThumb2',
  'mixamorigRightHandThumb3',
  'mixamorigRightHandThumb4',
  'mixamorigRightLeg',
  'mixamorigRightShoulder',
  'mixamorigRightToeBase',
  'mixamorigRightToe_End',
  'mixamorigRightUpLeg',
  'mixamorigSpine',
  'mixamorigSpine1',
  'mixamorigSpine2',
] as const;

export const CONTROL_NAMES: readonly string[] = [
  'body.pitch',
  'body.roll',
  'body.yaw',
  'head.pitch',
  'head.roll',
  'head.yaw',
  'leftElbow.bend',
  'leftHip.pitch',
  'leftHip.spread',
  'leftHip.twist',
  'leftKnee.bend',
  'leftShoulder.pitch',
  'leftShoulder.spread',
  'leftShoulder.twist',
  'rightElbow.bend',
  'rightHip.pitch',
  'rightHip.spread',
  'rightHip.twist',
  'rightKnee.bend',
  'rightShoulder.pitch',
  'rightShoulder.spread',
  'rightShoulder.twist',
  'torso.pitch',
  'torso.roll',
  'torso.yaw',
] as const;

export const BONE_COUNT = 65;
export const CONTROL_COUNT = 25;

